export default "__VITE_ASSET__DfSu13_d__"